import {
  callIcon,
  emailIcon,
  userIcon2,
  workIcon,
} from "assets/icons";
import React from "react";
import { useSelector } from "react-redux";
import EditProfile from "./EditProfile";

const UserProfile = () => {
  const { user, loading, error } = useSelector((state) => state.userProfile);
  // console.log('user?.user', user)

  return (
    <div className="myProfile">
      <h3 className="title">My Profile</h3>
      <EditProfile {...{ profile: user?.user?.profile }} />
      <div className="use_details">
        <ul>
          <li>
            <img src={userIcon2} alt="" /> <span>{user?.user?.name || "N/A"}</span>
          </li>
          <li>
            <img src={callIcon} alt="" /> <span>{user?.user?.contactNum || "N/A"}</span>
          </li>
          <li>
            <img src={emailIcon} alt="" />{" "}
            <span>{user?.user?.email || "N/A"}</span>
          </li>
          <li>
            <img src={workIcon} alt="" /> <span>{user?.user?.nameOfBusiness || "N/A"}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserProfile;
